enum IconFontName {
  // 右下角关闭
  CloseRightBottom = 0xe796,
  // 右上角关闭
  CloseRightTop = 0xe795,
  // 评星
  Rating = 0xe794,
  // Video
  VideoUpload = 0xe78f,
  // photo
  PhotoUpload = 0xe78e,
  // 减号
  Lessen = 0xe78d,
  // 更多
  More = 0xe78a,
  // 勾选
  Check = 0xe730,
  // 关闭
  Close = 0xe72f,
  // 加号
  Addition = 0xe72e,
  // 向上
  Up = 0xe71c,
  // 向下
  Down = 0xe71b,
  // 上一页
  Back = 0xe711,
  // 下一页
  Next = 0xe710,
  // 列表
  List = 0xe70d,
  // 地图
  Map = 0xe70a,
  // 合作
  Cooperation = 0xe709,
  // 物流
  Logistics = 0xe708,
  // 明细
  Detail = 0xe707,
  // 收益
  Earnings = 0xe706,
  // 售后
  Aftermarket = 0xe705,
  // 待评价
  Evaluate = 0xe704,
  // 待收货
  Reception = 0xe703,
  // 代发货
  Deliver = 0xe702,
  // 代付款
  Payment = 0xe701,
  // 购物
  Shopping = 0xe700,
  // 订单
  Order = 0xe6ff,
  // 礼物
  Gift = 0xe6fe,
  // 砍价
  Bargain = 0xe6fd,
  // 拼团
  Assemble = 0xe6fc,
  // 客服
  Service = 0xe6fb,
  // 积分
  Integral = 0xe6fa,
  // 店铺
  Store = 0xe6f9,
  // 密码
  Password = 0xe6f8,
  // 用户
  Admin = 0xe6f7,
  // 二维码
  QRcode = 0xe6f5,
  // 优惠券
  Coupons = 0xe6f4,
  // 红包
  Redpacke = 0xe6f3,
  // 奖杯
  Trophy = 0xe6f2,
  // 排行榜
  Rank = 0xe6f1,
  // 预览
  Preview = 0xe6f0,
  // 筛选
  Filtrate = 0xe6ed,
  // 编辑
  Edit = 0xe6ec,
  // 设置
  Setting = 0xe6eb,
  // 记录
  Record = 0xe6ea,
  // 哭脸
  Smile = 0xe6e9,
  // 普通
  Normal = 0xe6e8,
  // 哭脸
  Crying = 0xe6e7,
  // 警告
  Warning = 0xe6e6,
  // 帮助
  Help = 0xe6e5,
  // 错误
  Error = 0xe6e4,
  // 正确
  Right = 0xe6e2,
  // 减少
  Reduce = 0xe6e1,
  // 添加
  Add = 0xe6e0,
  // 视频
  Video = 0xe6df,
  // 直播
  Live = 0xe6de,
  // 图片
  Picture = 0xe6dd,
  // 相机
  Camera = 0xe6da,
  // 卡包
  Cardbag = 0xe6d9,
  // 银行卡
  Card = 0xe6d8,
  // 文件夹
  Folder = 0xe6d7,
  // 文件
  File = 0xe6d5,
  // 刷新
  Refresh = 0xe6d4,
  // 签到
  Sign = 0xe6d3,
  // 日历
  Calendar = 0xe6d2,
  // 导入
  Importing = 0xe6d0,
  // 发送
  Send = 0xe6cf,
  // 删除
  Delete = 0xe6ce,
  // 下载
  Download = 0xe6cc,
  // 分享
  Share = 0xe6cb,
  // 点赞
  Praise = 0xe6ca,
  // 评论
  Comment = 0xe6c9,
  // 收藏
  Collect = 0xe6c8,
  // 喜欢
  Like = 0xe6c7,
  // 麦克风
  Micphone = 0xe6c6,
  // 定位
  Location = 0xe6c5,
  // 搜索
  Search = 0xe6c4,
  // 扫一扫
  Scan = 0xe6c3,
  // 通知
  Inform = 0xe6c2,
  // 消息
  Message = 0xe6c1,
  // 我的
  Mine = 0xe6c0,
  // 购物车
  Cart = 0xe6bf,
  // 分类
  Class = 0xe6bb,
  // 发现
  Find = 0xe6ba,
  // 首页
  Index = 0xe6b8
}
export default IconFontName;
